import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
export const Timestamp = ({
  timestamp
}) => {
  var _I18n$moment$toISOStr;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: timestamp,
      format: "LLLL",
      type: "userTz"
    }),
    children: /*#__PURE__*/_jsx("time", {
      dateTime: (_I18n$moment$toISOStr = I18n.moment(timestamp).toISOString()) !== null && _I18n$moment$toISOStr !== void 0 ? _I18n$moment$toISOStr : undefined,
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: timestamp,
        format: "LT",
        type: "userTz"
      })
    })
  });
};